/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';
import type { RecommendationVerdict } from '../../types/finops';
import { formatDate } from './finopsFormat';

interface VerdictBadgeProps {
  verdict: RecommendationVerdict;
  migrateAt?: string | null;
}

// keep_aws -> gray, migrate_at -> yellow (with the target date), migrate_now -> green.
const VerdictBadge: React.FC<VerdictBadgeProps> = ({ verdict, migrateAt }) => {
  if (verdict === 'migrate_now') {
    return (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-500/20 text-green-400">
        Migrate now
      </span>
    );
  }
  if (verdict === 'migrate_at') {
    return (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-500/20 text-yellow-400">
        Migrate at {formatDate(migrateAt)}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-700 text-gray-300">
      Keep AWS
    </span>
  );
};

export default VerdictBadge;
